/* eslint-disable unicorn/prefer-blob-reading-methods,unicorn/consistent-destructuring */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols

import angular from 'angular';
import $ from 'jquery';
import * as jsonLogic from 'json-logic-js/logic';
import _ from 'lodash-es';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
import { Confirm } from '~/scripts/services/modal/modal';
import FileUpload from '~/scripts/services/model/file-upload';
import { ConfirmDeleteModal } from '~/utils/modals';
import PdfUtils from '~/components/pdf/pdf-utils';
import Utils from '~/scripts/services/utils';
import Droit from '~/scripts/services/model/droit';
import DroitDef from '~/scripts/services/model/droit-def';
import DroitCust from '~/scripts/services/model/droit-cust';
// eslint-disable-next-line import/no-cycle
import kformUtils from './utils/kform-utils';
import ModalUploadingController from '../upload/modal/modal-uploading.controller';
import templateModalUploadClassic from '../upload/modal/modal-uploading.html';
import Attribut from '~/scripts/services/model/attribut';
import Lock from '~/scripts/services/model/lock';
import Repre from '~/scripts/services/model/repre';

/* globals Knitiv */

/**
 * @typedef KformOptions
 * @property {boolean} [displayBreadcrumb]
 * @property {boolean} [displayKelse]
 * @property {boolean} [displayTabs]
 * @property {false | import('angular').bootstrap.ui.IModalInstanceService} [modal]
 * @property {'normal' | 'component_of'} [mode]
 * @property {string | undefined} [name]
 * @property {any} [newFile]
 * @property {any} [params]
 * @property {any} [parent]
 * @property {boolean} [preview]
 * @property {boolean} readOnly
 * @property {boolean} [tree]
 * @property {string} [tab]
 * @property {string} [uiActionOpenForm]
 * @property {number} [viewMode]
 */

/** ** old controller */
export const dataChanged = [];

export const checkJsonConditional = (component, json, row, data, form, onError) => {
	try {
		return jsonLogic.apply(json, {
			data,
			row,
			form,
			_,
		});
	}
	catch (error) {
		console.warn(`An error occurred in jsonLogic advanced condition for ${component.key}`, error);
		return onError;
	}
};

export default class KformController {
	#$injector;

	#$location;

	#$q;

	#$rootScope;

	#$sce;

	#$scope;

	#$translate;

	#$uibModal;

	#Agent;

	#Bookmark;

	#FileDownloadService;

	#FormService;

	#NodeService;

	#Notification;

	#UIActionService;

	#User;

	#areas;

	#formParent;

	#newKid;

	#oldData;

	#oldFiles;

	#oldListWidth;

	#oldName; // TODO unused?

	#pristine;

	#promiseExecScript;

	#rootFormKid;

	#temporaryFiles;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').location.ILocationService} $location
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Agent
	 * @param {import('~/components/bookmark/bookmark.model').default} Bookmark
	 * @param {import('~/components/download/download.service').FileDownloadServiceModel} FileDownloadService
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {import('~/scripts/services/node.service').default} NodeService
	 * @param {any} Notification
	 * @param {import('~/scripts/services/ui-action.service').UIActionService} UIActionService
	 * @param {any} User
	 */
	constructor(
		$injector,
		$location,
		$q,
		$rootScope,
		$sce,
		/** @type {Knitiv.Scope} */
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Agent,
		Bookmark,
		FileDownloadService,
		FormService,
		NodeService,
		Notification,
		UIActionService,
		User,
	) {
		this.btnSubmitDisabled = false;
		this.create = undefined;
		this.comment = undefined;
		this.connectedAgent = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.currentClassForm = undefined;
		this.dev = process.env.NODE_ENV !== 'production';
		this.disabled = undefined;

		/** @type {KformOptions} */
		this.defaultOptions = {
			displayBreadcrumb: true,
			displayKelse:      true,
			displayTabs:       true,
			modal:             false,
			mode:              'normal',
			name:              undefined,
			newFile:           undefined,
			parent:            null,
			preview:           false,
			readOnly:          true,
			tree:              false,
			tab:               'form',
			viewMode:          1,
		};

		/** @type {boolean} */
		this.error = false;

		/** @type {Record<import('@knitiv/api-client-javascript').KNode, FileUpload[]>} */
		this.files = {};

		this.formId = undefined;

		/**
		 * @type {Object<
		 *   import('@knitiv/api-client-javascript').KNode,
		 *   import('~/scripts/services/model/form').default
		 * >}
		 */
		this.forms = {};

		this.from = undefined;

		/** @type {string} */
		this.fullScreenMode = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		this.histo = {
			data:    undefined,
			loading: false,
		};

		/** @type {boolean} */
		this.loading = false;

		this.loadGraph = undefined;

		/** @type {string} */
		this.name = undefined;

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onBeforeSubmit = null;

		/** @type {?Function} */
		this.onSubmit = null;

		/** @type {KformOptions} */
		this.options = {};

		/** @type {import('tabulator-tables').RowComponent} */
		this.row = undefined;

		/** @type {Object<import('@knitiv/api-client-javascript').KNode, any>} */
		this.submissions = {};
		this.tab = undefined;
		this.user = undefined;

		this.#areas = [
			'file',
			'details',
			'wf',
		];
		this.#formParent = undefined;
		this.#newKid = undefined;
		this.#pristine = true;
		this.#oldData = {};
		this.#oldFiles = {};
		this.#oldListWidth = {};
		this.#oldName = undefined;
		this.#promiseExecScript = undefined;
		this.#rootFormKid = undefined;
		this.#temporaryFiles = [];

		this.#$injector = $injector;
		this.#$location = $location;
		this.#$q = $q;
		this.#$rootScope = $rootScope;
		this.#$sce = $sce;
		this.#$scope = $scope;
		this.$timeout = $timeout;
		this.#$translate = $translate;
		this.#$uibModal = $uibModal;
		this.#Agent = Agent;
		this.#Bookmark = Bookmark;
		this.#FileDownloadService = FileDownloadService;
		this.#FormService = FormService;
		this.#NodeService = NodeService;
		this.#Notification = Notification;
		this.#UIActionService = UIActionService;
		this.#User = User;
		this.Defaults = Defaults;
	}

	/**
	 * Adds a file to the current form
	 *
	 * @param {File} file File instance
	 * @param {?string} id File id (for kds) - if supplied, then replace it
	 * @returns {Promise<FileUpload>}
	 */
	async addFile(file, id = null) {
		let fileUpload;
		if (!this.options.readOnly && file && this.forms[this.currentClassForm].params.displayTabForm) {
			let indexFile = -1;

			if (!(this.currentClassForm in this.files)) {
				this.files[this.currentClassForm] = [];
			}

			if (id === null) {
				fileUpload = new FileUpload(this.#$injector, file);
				if (this.#$rootScope.kds) {
					fileUpload.id = this.#User.getRef();
					this.files[this.currentClassForm].push(fileUpload);
					this.forms[this.currentClassForm].params.defaultTab = 'form';
					indexFile = this.files[this.currentClassForm].length - 1;
				}
				else {
					// replace file
					this.files[this.currentClassForm] = [fileUpload];
				}
			}
			else {
				indexFile = this.files[this.currentClassForm].findIndex(file => file.id === id);
				if (indexFile >= 0) {
					fileUpload = this.files[this.currentClassForm][indexFile];
					// replace file
					fileUpload.kid = null;
					fileUpload.url = null;
					fileUpload.file = file;
					fileUpload.name = file.name;
					fileUpload.uploaded = false;
				}
			}

			this.forms[this.currentClassForm].formio.kformForm.$setDirty(); // TODO à vérifier
			this.forms[this.currentClassForm].isfile = false;
			this.forms[this.currentClassForm].viewer_engine = null;
			this.forms[this.currentClassForm].viewer_mimetype = file.type;

			if (!this.forms[this.currentClassForm].getName()) {
				this.forms[this.currentClassForm].setName(fileUpload.name);
				// Replace the KREPRE array with a shallow copy so the repre ngModel
				// detects the reference change and re-runs its validators with the new values
				if (this.submissions[this.currentClassForm]?.data.KREPRE) {
					const repre = [...this.forms[this.currentClassForm].repre];
					this.submissions[this.currentClassForm].data.KREPRE = repre;
					this.forms[this.currentClassForm].repre = repre;
				}
			}

			Object.entries(Defaults.viewerEnginesMimetypes)
				.some(([engine, mimetypeRegexp]) => {
					if (mimetypeRegexp.test(file.type)) {
						this.forms[this.currentClassForm].viewer_engine = engine;
						return true;
					}
					return false;
				});

			if (this.forms[this.currentClassForm].viewer_engine === 'pdf') {
				const fields = await APIV5.instance.docExtractFieldsGet({
					class_kid:     this.forms[this.currentClassForm].isa.objid,
					file_mimetype: file.type,
					file_name:     file.name,
					file_size:     file.size,
				}, { id: 'kform.add-file' });
				if (fields && Array.isArray(fields.value?.elts) && fields.value?.elts.length > 0) {
					const options = {
						search:   fields.value.elts,
						filename: file.name,
					};
					const pdfUtils = new PdfUtils(this.#$injector);
					const propositions = await pdfUtils.extractText(await file.arrayBuffer(), options);
					if (propositions?.length > 0) {
						this.fillFormSubmission(propositions.filter(proposition => proposition.enabled));
					}
				}
			}

			if (this.forms[this.currentClassForm].viewer_engine) {
				this.forms[this.currentClassForm].isfile = true;
			}

			if ([
				'pdf',
				'video',
			].includes(this.forms[this.currentClassForm].viewer_engine)) {
				this.$timeout(() => {
					fileUpload.url
						= this.#$sce.trustAsResourceUrl(URL.createObjectURL(new Blob([file], { type: file.type })));
					fileUpload.loaded = file.size;
				});
			}
			else if (this.forms[this.currentClassForm].viewer_engine === 'image') {
				fileUpload.url = {
					rotate: 0,
					url:    URL.createObjectURL(new Blob([file], { type: file.type })),
					zoomed: false,
				};
				fileUpload.loaded = file.size;
			}
			else if (this.forms[this.currentClassForm].viewer_engine === 'json') {
				const fr = new FileReader();
				fr.addEventListener('load', () => {
					try {
						fileUpload.url = JSON.parse(fr.result.toString());
						fileUpload.loaded = fr.result.length;
					}
					catch {
						this.#Notification.error({
							title:   this.#$translate.instant('error.title'),
							message: this.#$translate.instant('error.no-json-file'),
						});
					}
					this.#$scope.$apply();
				});
				fr.readAsText(file);
			}
			else if (fileUpload && [
				'text',
				'html',
				'mail',
			].includes(this.forms[this.currentClassForm].viewer_engine)) {
				const fr = new FileReader();
				fr.addEventListener('load', () => {
					fileUpload.url = fr.result.toString();
					fileUpload.loaded = file.size;
					this.#$scope.$apply();
				});
				fr.readAsText(file);
			}
		}
		return fileUpload;
	}

	async addFiles(files) {
		return files.map(file => this.addFile(file));
	}

	/**
	 * Adds a form or a subform
	 *
	 * @param {Object} formClass class details
	 * @param {Object} parent parent details
	 * @param {Object} options form options
	 * @returns {Promise} Promise result
	 */
	async addForm(formClass, parent, options = {}) {
		const create = !('kid' in formClass);
		const kid = 'kid' in formClass ? formClass.kid : formClass.isa;
		/** @type {any} */
		let defaultWorkflow;

		if (this.options?.parent) {
			// eslint-disable-next-line no-param-reassign
			({ parent } = this.options);
		}

		// eslint-disable-next-line no-param-reassign
		options = _.merge({
			rg: true,
			create,
		}, options, this.options.params || {});

		if (create && !options.current_kid) {
			options.current_kid = `K_NODE;${this.#User.getRefNr()}`;
		}

		if (parent && !options.noShow) {
			this.loading = true;
			if (parent.OBJECT_LIST && Object.keys(parent.OBJECT_LIST).length > 0) {
				options.current_kid = Object.keys(parent.OBJECT_LIST)[0];
			}
			this.forms[this.currentClassForm].formio.kformForm.$setDirty();
		}

		if (parent) {
			options.parent = _.cloneDeep(parent);
			delete options.method_kid;
			delete options.referent_kid;
			delete options.parent.k;
			delete options.parent.kndef;
			delete options.parent.kndefext;
		}
		else if (create) {
			// eslint-disable-next-line unicorn/prevent-abbreviations
			const def = await this.#NodeService.loadDef(kid);
			if (def) {
				defaultWorkflow = def.wf;
			}
		}

		if (this.options.uiActionOpenForm && options.current_kid) {
			const uiAction = this.#UIActionService.uiActions[this.options.uiActionOpenForm];
			if (uiAction) {
				options.items = [
					{
						target_objnum: options.current_kid,
						submission:    {
							[options.current_kid]: { ...uiAction.submission }
						},
					}
				];
				delete uiAction[this.options.uiActionOpenForm];
			}
			this.options.uiActionOpenForm = undefined;
		}

		try {
			const result = await this.#FormService.load(kid, options);
			this.error = false;
			if (create && this.#newKid && !parent) {
				formClass.kid = this.#newKid;
			}
			await this.loadForm(result, parent, formClass, create, false, options);
			const form = this.forms[this.currentClassForm];
			if (create && !form.creating) {
				form.creating = true;
			}
			if (create && !parent && this.#newKid) {
				formClass.kid = this.#newKid;
			}
			if (defaultWorkflow) {
				form.wf = { ...form.wf, ...defaultWorkflow };
			}
			if (formClass.file) {
				await this.addFile(formClass.file);
			}
			else if (formClass.files) {
				await this.addFiles(formClass.files);
			}
		}
		catch (error) {
			console.error(error);
			// this.error = true;
			this.loading = false;
		}
	}

	/**
	 * Adds a link to an existing node (from ktable)
	 *
	 * @param {Object} path path with values details
	 * @param {Object} parent parent details
	 * @param {string} key component key of the ktable
	 * @param {string} type value type
	 */
	addLinkTo(path, parent, key, type) {
		this.#$scope.$broadcast(`ktable-refresh-${this.currentClassForm}-${key}`);
		this.forms[this.currentClassForm].linkTo.push({ key, path, type });
	}

	/**
	 * Stores temp files from MF (for use later with loadForm method)
	 *
	 * @param {Array} files Files submitted from MF
	 */
	addTmpFiles(files) {
		this.#temporaryFiles.push(...files);
	}

	backupFiles(formKid) {
		this.#oldFiles[formKid] = { ...this.files[formKid] };
	}

	/**
	 * Restore list pane
	 */
	back() {
		this.#$scope.$emit('List.toggle-list', 'full');
	}

	/**
	 * Adds a bookmark
	 */
	bookmarkAdd() {
		this.#Bookmark.add(this.forms[this.kid].name, {
			data: {
				kid: this.forms[this.kid].kid,
			},
			type: 'node',
		});
	}

	/**
	 * Calls history
	 */
	async callHisto() {
		this.histo.data = undefined;
		if (this.forms[this.currentClassForm].params.displayTabHisto === true) {
			this.histo.loading = true;
			try {
				this.histo.data = await APIV5.instance.objectHisto(
					this.forms[this.currentClassForm].kid,
					{ id: 'kform-tab-histo.load' },
				);
				this.histo.loading = false;
			}
			catch (error) {
				this.histo.loading = false;
				console.error(error);
			}
			this.$timeout(() => {
				this.#$scope.$apply();
			});
		}
	}

	/**
	 * Call graph
	 */
	callGraph() {
		this.loadGraph = true;
	}

	/**
	 * Cancels all forms
	 *
	 * @param {boolean} force Cancel the form without confirmation
	 * @param {Event} event Event object
	 * @returns {Promise} sucessful return
	 */
	async cancel(force, event) {
		if (
			!force
			&& this.forms[this.currentClassForm].parent?.kid in this.submissions
		) {
			const parent = this.forms[this.currentClassForm].parent.kid;

			if (this.forms[this.currentClassForm].create && this.forms[this.currentClassForm].creating) {
				await this.reset();
			}

			if (parent in this.forms) {
				this.currentClassForm = parent;
				this.selectedForm = this.forms[parent].branch;
				this.setName();
				if (this.forms[this.currentClassForm].script) {
					this.kexecScriptWrapper(this.currentClassForm, {
						origin: 'kform',
						method: 'cancel',
					});
				}
			}
		}
		else {
			if (this.#formParent) {
				if (this.#$scope.$parent.submissions && this.currentClassForm in this.#$scope.$parent.submissions) {
					delete this.#$scope.$parent.submissions[this.currentClassForm];
				}
				if (this.#$scope.$parent.forms && this.currentClassForm in this.#$scope.$parent.forms) {
					delete this.#$scope.$parent.forms[this.currentClassForm];
				}
			}

			if (
				this.#pristine
				&& this.forms[this.currentClassForm].formWF?.$pristine
				&& this.forms[this.currentClassForm].formRights?.$pristine
			) {
				this.#$scope.$emit('Form.cancel');
				await this.reset();
				if (typeof this.onCancel === 'function') {
					this.onCancel();
				}
			}
			else {
				const modal = new Confirm(this.#$injector);
				const answer = await modal.open({
					title:  this.#$translate.instant('object.confirm-delete-title'),
					body:   `<p><b>${this.#$translate.instant('form.confirm-cancel-title')}</b></p>
<p>${this.#$translate.instant('form.confirm-cancel-message')}</p>`,
					accept: {
						label: this.#$translate.instant('common.ok'),
						type:  'primary',
					},
					cancel: {
						label: this.#$translate.instant('common.cancel'),
						type:  'warning',
					},
				});

				// eslint-disable-next-line consistent-return
				this.#$scope.$evalAsync(() => {
					if (answer) {
						if (typeof this.onCancel === 'function') {
							this.#$scope.$emit('Form.cancel');
							this.reset();
							if (typeof this.onCancel === 'function') {
								this.onCancel();
							}
						}
						this.#$rootScope.showSearch = true;
						return true;
					}
					if (event) {
						event.preventDefault();
					}
				});
			}
		}

		return false;
	}

	/**
	 * Copy link preview
	 */
	copyLinkPreview() {
		this.forms[this.currentClassForm].copyLinkPreview();
	}

	/**
	 * Deletes the node of the specified form
	 *
	 * @param {import('~/scripts/services/model/form').default} form Form instance
	 */
	async delete(form) {
		const modal = new ConfirmDeleteModal(this.#$injector);
		const answer = await modal.open(form.getName());

		if (answer) {
			await this.#FormService.delete(form.kid);
			if (this.row) {
				this.row.getTable()
					.deleteRow(form.kid);
			}
			this.#Notification.info({
				title:   this.#$translate.instant('object.successfully-deleted-title'),
				message: this.#$translate.instant('object.successfully-deleted-message'),
			});
		}
	}

	/**
	 * Removes a file from the specified form
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {import('~/scripts/services/model/file-upload').default} file
	 * @returns {Promise<boolean>}
	 */
	async detachFile(form, file) {
		const modal = new ConfirmDeleteModal(this.#$injector);
		const answer = await modal.open(file?.name || this.#$translate.instant('common.document'));

		if (answer && form?.kid) {
			let result;

			if (this.#$rootScope.kds) {
				file.deleted = true;
				result = true;
				this.forms[this.currentClassForm].formio.kformForm.$setDirty();
			}
			else {
				result = file.uploaded && await this.#FormService.detachFile(form.kid) || !file.uploaded;
			}

			if (result) {
				if (this.row) {
					await this.row.update({
						file:           0,
						thumb_icon:     undefined,
						thumb_mimetype: undefined,
						viewer_engine:  undefined,
					});
				}
				const indexFile = this.files[form.kid].findIndex(f => f.id === file.id);
				if (indexFile >= 0 && !this.#$rootScope.kds) {
					this.files[form.kid].splice(indexFile, 1);
					form.isfile = this.files[form.kid].length > 0;
				}
				return true;
			}
		}
		return false;
	}

	/**
	 * Edits the current form
	 *
	 * @returns {Promise<boolean>}
	 */
	async edit() {
		if (!this.forms[this.kid].params.editable) {
			return false;
		}

		if (
			// Is in readonly mode
			this.options.readOnly
			// Kid is in the form
			&& this.kid in this.forms
			// I have the rights to edit the node
			&& this.forms[this.kid].checkDroit(Defaults.DROIT.MODIFY)
		) {
			// Backup current data
			this.#oldData[this.kid] = {
				form:      _.cloneDeep(this.submissions[this.kid].data),
				droit:     _.cloneDeep(this.forms[this.kid].droit),
				droitcust: _.cloneDeep(this.forms[this.kid].droitcust),
				droitdef:  _.cloneDeep(this.forms[this.kid].droitdef),
				workflow:  _.cloneDeep(this.forms[this.kid].workflow),
			};

			this.#oldName = this.forms[this.kid].name;

			if (
				this.forms[this.kid].lock.locked
				&& this.#$rootScope.context.profil.kid === this.forms[this.kid].lock.profil.kid
			) {
				this.options.readOnly = false;
				this.#$scope.$emit('Form.edit');
				if (this.row) {
					this.row.update({ edit: true });
				}
				return true;
			}

			try {
				const lock = await this.#FormService.lock(this.forms[this.kid]);
				this.options.readOnly = false;
				this.#$scope.$emit('Form.edit');
				this.$timeout(() => {
					this.forms[this.kid].lock = new Lock({
						...lock,
						locked: true,
					});
					if (this.row) {
						this.row.update({
							lock: this.forms[this.kid].lock,
							edit: true,
						});
					}
				});
				return true;
			}
			catch (/** @type {any} */ error) {
				console.error(error);
			}
		}

		await this.cancel(true, null);
		return true;
	}

	fillFormSubmission(propositions) {
		for (const [key, component] of Object.entries(this.forms[this.currentClassForm].map)) {
			for (const proposition of propositions) {
				if (proposition.assignto.type === 'KREPRE') {
					this.forms[this.currentClassForm].setName(proposition.str);
					this.submissions[this.currentClassForm].data.KREPRE = this.forms[this.currentClassForm].repre;
				}
				else {
					// remove incoherent flow in index 0 of path
					if (proposition.assignto.path?.length > 0 && 'flow' in proposition.assignto.path[0]) {
						delete proposition.assignto.path[0].flow;
					}
					if (component.path?.length > 0 && 'flow' in component.path[0]) {
						delete component.path[0].flow;
					}
					if (component.path && _.isEqual(proposition.assignto.path, component.path)) {
						// convert string to double
						if (component.type_kid === 'K_NODE;DOUBLE') {
							proposition.str = proposition.str.replace(' ', '').replace(',', '.');
						}

						switch (component.type) {
						case 'currency': {
							this.submissions[this.currentClassForm].data[key]
								= Number.parseFloat(proposition.str.replace(' ', '').replace(',', '.'));
							break;
						}

						case 'date': {
							this.submissions[this.currentClassForm].data[key] = Utils.parseDate(proposition.str);
							break;
						}

						case 'mf': {
							this.submissions[this.currentClassForm].data[key] = [{ name: proposition.str }];
							break;
						}

						case 'smartfield': {
							this.submissions[this.currentClassForm].data[key] = { name: proposition.str };
							break;
						}

						default: {
							this.submissions[this.currentClassForm].data[key] = proposition.str;
							break;
						}
						}
					}
				}
			}
		}
	}

	/**
	 * Generates the breadcrumb of the specified form
	 *
	 * @param {string} kid KID of the form
	 * @returns {Array} the generated breadcrumb
	 */
	getBreadCrumb(kid) {
		const breadcrumb = [];
		if (kid in this.forms) {
			breadcrumb.unshift(this.forms[kid]);
			let { parent } = this.forms[kid];
			while (parent) {
				breadcrumb.unshift(this.forms[parent.kid]);
				parent = parent.kid in this.forms ? this.forms[parent.kid].parent : null;
			}
		}

		return breadcrumb;
	}

	// eslint-disable-next-line class-methods-use-this
	getName(form) {
		let name = form.isa.objname;
		if (form.name) {
			name += ` : ${form.name}`;
		}
		return name;
	}

	async kexecScript(formKid, source) {
		if (this.forms && formKid in this.forms && this.forms[formKid].script) {
			this.forms[formKid].getValue = key => (
				this.submissions[formKid]?.data
				&& key in this.submissions[formKid].data
				&& this.submissions[formKid].data[key]
			);

			try {
				this.#FormService.evaluate(this.forms[formKid].script, {
					api:  APIV5.instance,
					data: this.submissions[formKid].data,
					form: this.forms[formKid],
				});
				this.loading = false;
			}
			catch (error) {
				console.error(error, source);
				this.#Notification.error({
					title:   this.#$translate.instant('error.title'),
					message: this.#$translate.instant('error.script-exec'),
				});
				this.options.readOnly = true;
				this.disabled = true;
				this.loading = false;
				// TODO: fix infinite loop!
				// this.cancel(true, null);
				await APIV5.instance.sysBackTrace({
					command: 'FormService.evaluate',
					data:    this.submissions[formKid].data,
					error:   error.toString(),
					form:    this.forms[formKid],
				}, {
					id: 'kform.kexec-script',
				});
			}
			this.#promiseExecScript = undefined;
		}
	}

	kexecScriptWrapper(formKid, source) {
		if (this.#promiseExecScript) {
			this.$timeout.cancel(this.#promiseExecScript);
		}
		this.#promiseExecScript = this.$timeout(() => this.kexecScript(formKid, source), 500);
	}

	/**
	 * Loads the form after calling FormService.load
	 *
	 * @param {{
	 *   form: import('~/scripts/services/model/form').default,
	 *   generic: boolean,
	 *   kid: import('@knitiv/api-client-javascript').KNode,
	 *   nrReplace: Record<import('@knitiv/api-client-javascript').KNode, import('@knitiv/api-client-javascript').KNode>
	 * }} result output of FormService.load
	 * @param {any} parent parent details
	 * @param {any} formClass class details
	 * @param {boolean} create create flag
	 * @param {boolean} refresh refresh flag
	 * @param {any} options don't show the form
	 * @returns {import('angular').IPromise} Promise result
	 */
	async loadForm(result, parent, formClass, create, refresh, options = {}) {
		const {
			files,
			form,
			generic,
			kid,
		} = result;
		if (!form) {
			return this.#$q.reject();
		}

		form.generic = generic;
		form.formKid = kid;
		form.kid = formClass.kid ?? form.kid ?? `K_NODE;${this.#User.getRefNr()}`;
		form.id = `KF${form.kid.split(';')[1]}`;

		// if (result.nrReplace) {
		// 	this.replaceKid(result.nrReplace);
		// }

		if (formClass.ktableController) {
			if (create) {
				formClass.ktableController.tempKid = form.kid;
			}
			this.options.ktableKey = formClass.ktableController.component?.key;
		}

		if (formClass.cardGridController && create) {
			formClass.cardGridController.tempKid = form.kid;
		}

		this.selectedForm = form.kid;
		form.parent = parent;

		if (parent && parent.kid in this.forms && !this.forms[parent.kid].nodes.some(form2 => form2.kid === form.kid)) {
			this.forms[parent.kid].nodes.push(form);
		}

		if (create && !parent) {
			const repreFromUrl = this.#$location.search().repre;
			if (!form.name && repreFromUrl) {
				form.setName(repreFromUrl);
			}
			else if (this.options.name) {
				form.setName(this.options.name);
			}
		}

		if (create || form.new_isa) {
			form.modified = true;
		}

		const { submission } = result;
		if (refresh && form.kid in this.forms && this.forms[form.kid]) {
			// Merge the form from refresh action
			_.merge(this.forms[form.kid], form);
			// _.merge creates plain objects for array items beyond the original length,
			// losing the Repre prototype and its methods (e.g. exportForObjectSet)
			this.forms[form.kid].repre = form.repre;
			this.submissions[form.kid].data = submission.data;
			this.submissions[form.kid].params = submission.params;
		}
		else {
			this.submissions[form.kid] = submission;
			this.forms[form.kid] = form;
		}

		if (this.submissions[form.kid].data.KREPRE) {
			this.submissions[form.kid].data.KREPRE = this.submissions[form.kid].data.KREPRE.map(
				(/** @type {any} */ repre) => new Repre(repre),
			)
		}

		if (!this.submissions[form.kid].kattribut) {
			this.submissions[form.kid].kattribut = [];
		}

		if (!this.submissions[form.kid].kdroit) {
			this.submissions[form.kid].kdroit = [];
		}

		if (!this.submissions[form.kid].kdroitcust) {
			this.submissions[form.kid].kdroitcust = [];
		}

		if (!this.submissions[form.kid].kdroitdef) {
			this.submissions[form.kid].kdroitdef = [];
		}

		if (!this.submissions[form.kid].krepre) {
			this.submissions[form.kid].krepre = [];
		}
		this.submissions[form.kid].krepre = this.submissions[form.kid].krepre.map(
			(/** @type {any} */ repre) => new Repre(repre),
		);

		if (!this.submissions[form.kid].wf) {
			this.submissions[form.kid].wf = [];
		}

		form.attribut = this.submissions[form.kid].kattribut.map(a => new Attribut(a));

		form.droit = this.submissions[form.kid].kdroit.map(d => new Droit(d));
		if (this.submissions[form.kid].kdroitcust) {
			form.droitcust.push(...this.submissions[form.kid].kdroitcust.map(d => new DroitCust(d)));
		}
		if (this.#$rootScope.context?.role.mode === 'ADMIN_SUPER' && this.submissions[form.kid].kdroitdef) {
			form.droitdef.push(...this.submissions[form.kid].kdroitdef.map(d => new DroitDef(d)));
		}

		let { defaultTab } = form.params;

		// set defaultTab = 'form' if defaultTab is 'file' and we are in preview mode
		if (this.options.preview && defaultTab === 'file') {
			defaultTab = 'form';
		}

		form.tab = this.tab || this.options.tab || defaultTab || 'form';

		if (!this.options?.modal) {
			this.#$location.search('tab', form.tab)
				.replace();
		}

		// eslint-disable-next-line unicorn/consistent-destructuring
		this.options.tree = form.params.tree;

		if (this.options.locked !== undefined) {
			form.lock.locked = this.options.locked;
		}

		if (this.#temporaryFiles.length > 0) {
			for (const file of this.#temporaryFiles) {
				this.files[form.kid].push(new FileUpload(this.#$injector, file.file, file.name));
			}
			this.#temporaryFiles.length = 0;
			form.isfile = true;
		}
		else if (!this.#$rootScope.kds && form.isfile) {
			const file = new FileUpload(this.#$injector, {
				size: form.getAttribute('F_SIZE')?.value,
				type: form.getAttribute('F_MIMETYPE')?.value,
				name: form.getAttribute('F_FILENAME')?.value,
			});

			file.uploaded = true;
			this.files[form.kid] = [file];

			// if (this.options.preview && form.tab === 'file') {
			// 	form.tab = 'form';
			// }
		}
		else if (this.#$rootScope.kds && files.length > 0) {
			this.files[form.kid] = files
				? files.map(file => new FileUpload(this.#$injector, file, file.name.user))
				: [];
		}
		else if (!this.#$rootScope.kds) {
			if (!(this.files)) {
				this.files = {};
				this.#oldFiles = {};
			}
			this.files[form.kid] = [];
			this.#oldFiles[form.kid] = _.merge({}, this.files[form.kid]);
		}

		// if (form.tab === 'file' && this.options.readOnly) {
		// 	form.tab = form.params.defaultTab;
		// }

		// recherche du form parent dans le scope
		if (this.options.mode === 'component_of') {
			let scopeParent = this.#$scope.$parent;
			while (scopeParent && !('form' in scopeParent && scopeParent.form)) {
				scopeParent = scopeParent.$parent;
				this.#formParent = scopeParent.form;
			}

			if (scopeParent) {
				scopeParent = scopeParent.$parent;
			}

			// fusion des données forms + submission (à plat)
			if ('forms' in scopeParent && 'submissions' in scopeParent) {
				_.merge(scopeParent.forms, this.forms);
				_.merge(scopeParent.submissions, this.submissions);
				_.merge(scopeParent.files, this.files);
			}

			// recherche dans la map en cours s'il y a un definedby sur le parent
			if (this.#formParent.create) {
				for (const [key, component] of Object.entries(form.map)) {
					if (this.#formParent && this.#formParent.isa.objid === component.kid) {
						this.submissions[form.kid].data[key] = [
							{
								kid:  this.#formParent.kid,
								name: this.#formParent.getName(),
							},
						];
					}
				}
			}
		}

		this.forms[form.kid].isTerminal = false;
		if (!options.noShow && (!parent || (parent && !form.lastForm))) {
			this.currentClassForm = form.kid;
		}
		else {
			this.currentClassForm = parent.kid;
			this.forms[form.kid].isTerminal = true;
		}

		if (formClass.name && !this.forms[form.kid].name) {
			this.forms[form.kid].name = formClass.name;
		}

		if (!this.forms[form.kid].isTerminal) {
			this.setName();
		}

		if (parent && parent.field && parent.kid in this.submissions && this.#rootFormKid) {
			if (this.submissions[parent.kid].data[parent.field] === undefined) {
				this.submissions[parent.kid].data[parent.field] = [{ kid: form.kid }];
			}
			else {
				this.submissions[parent.kid].data[parent.field][parent.k || 0].kid = form.kid;
			}
			this.#FormService.mfCacheAdd(
				form.isa.objid,
				this.submissions[parent.kid].data[parent.field][parent.k || 0],
				parent.kid,
			);
		}

		// Probe for repre update from MF
		this.#$scope.$watch(() => (this.submissions[form.kid] && 'KREPRE' in this.submissions[form.kid].data
			? this.submissions[form.kid].data.KREPRE : undefined), (newRepre, oldRepre) => {
			if (
				newRepre && !_.isEqual(newRepre, oldRepre) && form.kid in this.forms
				&& form.kid in this.forms && this.forms[form.kid] && this.submissions[form.kid].data.KREPRE
			) {
				this.forms[form.kid].repre = this.submissions[form.kid].data.KREPRE.map(
					repre => repre instanceof Repre ? repre : new Repre(repre),
				);
				this.forms[form.kid].name = this.forms[form.kid].getName(true);
				this.forms[form.kid].modified = true;

				for (const [formKid, sform] of Object.entries(this.forms)) {
					for (const [sfield, map] of Object.entries(sform.map)) {
						if (
							map.type === 'mf'
							&& map.kid === this.forms[form.kid].isa.objid
							&& this.submissions[formKid].data[sfield]
							&& this.submissions[formKid].data[sfield].length > 0
						) {
							for (const value of Object.values(this.submissions[formKid].data[sfield])) {
								if (value.kid === form.kid) {
									value.name = this.forms[form.kid].getName();
								}
							}
						}
					}
				}

				// if (sparent && 'field' in sparent) {
				// 	this.submissions[sparent.kid].data[sparent.field][sparent.k || 0].name = this.forms[form.kid].getName();
				// }
				this.setName();
			}
		}, true);

		if (!this.#rootFormKid) {
			this.#rootFormKid = form.kid;
			this.#FormService.reset();

			// Probe for pristine update
			this.#$scope.$watch(`$ctrl.forms["${this.#rootFormKid}"].formio.kformForm.$pristine`, (p, oldp) => {
				if (p && !oldp && this.forms[this.#rootFormKid].modified) {
					// trick to avoid pristine form when coming from child form
					this.forms[this.#rootFormKid].formio?.kformForm?.$setDirty();
				}
				else {
					this.#pristine = p;
				}
			});
		}

		if (form.components.length > 0) {
			const componentsChildren = {};

			for (const sform of Object.values(this.forms)) {
				for (const [k, map] of Object.entries(sform.map)) {
					if (map && 'path' in map) {
						for (const path of map.path) {
							if (!(path in componentsChildren)) {
								componentsChildren[path] = [];
							}
							if (!componentsChildren[path].includes(k)) {
								componentsChildren[path].push(k);
							}
						}
					}
				}
			}

			// il s'agit d'appeler les champ de manière recursive ... et de faire les watch en commençant par le plus bas
			// pour qu'ils soient tous pris en compte.

			// on prends tout les objets qui sont enfant

			// { K2000 null } { CERVEAU : down }

			// const buildDict = () => {
			// 	const returnValue = [];
			// 	for (const [key, map] of Object.entries(this.forms[form.kid].map)) {
			// 		if (typeof map === 'object' && 'path' in map && map.path.length > 0) {
			// 			returnValue.push({
			// 				key,
			// 				current: {
			// 					kid:        map.path.at(-1)?.kid,
			// 					linker_kid: map.path.at(-1)?.linker_kid,
			// 				},
			// 				parent:  {
			// 					kid:        map.path.at(-2)?.kid,
			// 					linker_kid: map.path.at(-2)?.linker_kid,
			// 				},
			// 			});
			// 		}
			// 	}
			// 	return returnValue;
			// };

			// let n = 0;
			// const buildTree = (sparent, dic, tree) => {
			// 	for (const dicElement of dic) {
			// 		if (dicElement.parent.kid === sparent.kid && dicElement.parent.linker_kid === sparent.linker_kid) {
			// 			const treeElement = {
			// 				kid:        dicElement.kid,
			// 				isa:        dicElement.current.kid,
			// 				linker_kid: dicElement.current.linker_kid,
			// 				children:   [],
			// 			};
			// 			tree.push(treeElement);
			//
			// 			if (dicElement.current.kid === form.isa.objid) {
			// 				n++;
			// 			}
			//
			// 			if (n < 10) {
			// 				buildTree(dicElement.current, dic, treeElement.children);
			// 			}
			// 		}
			// 	}
			// };

			const isElementOf = (children, isa) => {
				let returnValue = false;
				// eslint-disable-next-line max-len
				// eslint-disable-next-line unicorn/no-array-for-each,no-shadow,unicorn/no-array-method-this-argument,unicorn/no-array-callback-reference
				angular.forEach(children, element => {
					if (element.isa === isa) {
						returnValue = element.kid;
					}
				});
				return returnValue;
			};

			const tree = [];
			// buildTree(form.isa.objid, buildDict(), tree);

			const changeSubmission = k => {
				let returnValue = '';
				if (this.submissions[form.kid]) {
					if (Array.isArray(this.submissions[form.kid].data[k]) && this.submissions[form.kid].data[k].length > 0) {
						// eslint-disable-next-line max-len
						// eslint-disable-next-line unicorn/no-array-for-each,unicorn/no-array-method-this-argument,unicorn/no-array-callback-reference
						angular.forEach(this.submissions[form.kid].data[k], element_ => {
							returnValue += `${element_.kid}`;
						});
					}
					else if (Array.isArray(this.submissions[form.kid].data[k])) {
						returnValue += 0;
					}
					else {
						returnValue += this.submissions[form.kid].data[k];
					}
				}
				return `'${returnValue}'`;
			};

			const resetChildren = (stree, exceptKey) => {
				// eslint-disable-next-line max-len
				// eslint-disable-next-line unicorn/no-array-method-this-argument,unicorn/no-array-for-each,unicorn/no-array-callback-reference
				angular.forEach(stree, t => {
					if (t.kid !== exceptKey) {
						this.submissions[form.kid].data[t.kid] = form.flatTypes[t.kid] === 'mf' ? [] : undefined;
						resetChildren(t.children);
					}
				});
			};

			const setChildren = (k, children, newValue, index) => {
				// TODO rustine en attendant un couche de cache.
				if (!newValue[index].kid.startsWith('K_NODE;_NR_')) {
					return APIV5.instance.objectInfo(
						{ kid: newValue[index].kid },
						{ id: 'kform.load-form.set-children' },
					)
						.then(sresult => {
							if (COMPOSED_OF in sresult.link.list.from) {
								for (const link of Object.values(sresult.link.list.from[COMPOSED_OF].list)) {
									const childKid = isElementOf(children, link.isa);
									if (childKid && typeof childKid === 'string') {
										if (form.flatTypes[childKid] === 'mf') {
											if (
												!(childKid in this.submissions[form.kid].data)
												|| this.submissions[form.kid].data[childKid] === undefined
											) {
												this.submissions[form.kid].data[childKid] = [];
											}
											this.submissions[form.kid].data[childKid].push({
												kid:  link.objnum2_kid,
												name: link.objname,
											});
										}
										else if (form.flatTypes[childKid] === 'smartfield') {
											this.submissions[form.kid].data[childKid] = {
												kid:  link.objnum2_kid,
												name: link.objname,
											};
										}
										else {
											this.submissions[form.kid].data[childKid] = link.objname;
										}
									}
								}
							}
							return this.$timeout(() => {
								this.#$scope.$apply();
							});
						})
						.catch(console.error);
				}
				return this.#$q.reject();
			};

			const watch = (key, children) => {
				this.#$scope.$watch(() => changeSubmission(key), () => {
					if (this.submissions[form.kid]) {
						const newValue = this.submissions[form.kid].data[key];
						if (Array.isArray(newValue) && newValue[0] && 'kid' in newValue[0]) {
							resetChildren(children, key);
							setChildren(key, children, newValue, 0);
						}
					}
				});
			};

			const parseTree = t => {
				for (const te of t) {
					parseTree(te.children);
					watch(te.kid, te.children);
				}
			};

			parseTree(tree);
		}

		// if (this.options.editMode === 'edit') {
		// 	await this.edit();
		// }

		return this.$timeout(() => {
			// TODO check use
			// if (!branch.lastForm) {
			//	this.selectedForm = branch;
			// }
			if (this.options.newFile) {
				this.addFile(this.options.newFile);
			}

			this.$timeout(() => {
				if (this.forms[form.kid]?.formio?.kformForm) {
					if (refresh) {
						this.forms[form.kid].formio.kformForm.$commitViewValue();
					}
					if (this.forms[form.kid].parent) {
						this.forms[form.kid].formio.kformForm.$setDirty();
					}
					else {
						if (!refresh) {
							this.forms[form.kid].modified = false;
						}
						this.forms[form.kid].formio.kformForm.$setPristine();
						this.forms[form.kid].formio.kformForm.$setUntouched();
					}
				}
				if (refresh) {
					// force JS conditional reexec after refresh
					this.forms[form.kid].cacheKeys = {};

					// set dirty form after refresh
					if (this.forms[form.kid].formio?.kformForm) {
						this.forms[form.kid].formio.kformForm.$setDirty();
					}
				}

				if (this.forms[form.kid]?.script) {
					// this.$timeout(() => {
					this.kexecScriptWrapper(form.kid, {
						origin: 'kform',
						method: 'loadForm',
					}); // jshint ignore:line
					// }, 500);
				}
				else {
					this.loading = false;
				}

				this.#$scope.$apply();
			});

			this.#$scope.$apply();
			return this.forms[form.kid];
		}, 100);
	}

	/**
	 * Opens the specified form
	 *
	 * @param {string} formKid KID of the form
	 * @param {Object} parent parent details
	 * @param {string} tab tab to open
	 */
	async openForm(formKid, parent, tab = 'form') {
		if (!(formKid in this.forms)) {
			await this.addForm({ kid: formKid }, parent);
		}

		if (formKid in this.forms) {
			this.currentClassForm = formKid;
			this.selectedForm = this.forms[formKid].branch;
			this.setName();
			if (parent) {
				this.forms[formKid].fixKtableOptionParentCreate(parent.create);
			}
			await this.$timeout(() => {
				if (this.forms[formKid].script) {
					this.kexecScriptWrapper(formKid, {
						origin: 'kform',
						method: 'openForm',
					});
				}
				this.forms[this.currentClassForm].tab = tab;
			});
		}
	}

	/**
	 * Redirects to the parent form of current form
	 */
	parent() {
		if (this.forms[this.currentClassForm]?.parent?.kid in this.submissions) {
			const parent = this.forms[this.currentClassForm].parent.kid;
			if (parent) {
				this.currentClassForm = parent;
				this.selectedForm = this.forms[parent].branch;
				this.setName();
			}
		}
	}

	recursiveDeleteForm(kid) {
		if (this.forms && kid in this.forms) {
			this.forms[kid].nodes.map(form => this.recursiveDeleteForm(form.kid));
			delete this.forms[kid];
			delete this.submissions[kid];
			delete this.files[kid];
		}
	}

	/**
	 * Refreshes the current form
	 */
	async refreshForm() {
		const form = this.forms[this.currentClassForm];
		const formKid = form.kid;

		this.loading = true;

		if (form.components) {
			form.components.length = 0;
		}
		else {
			form.components = [];
		}

		try {
			const result = await this.#FormService.refresh(
				form.create ? form.isa.objid : form.kid,
				{
					create:      form.create,
					current_kid: form.kid,
					detail:      'OBJECTINFO',
					modified:    form.modified,
					rg:          true,
					parent:      form.parent,
				},
				this.options.readOnly ? [] : this.forms,
				this.options.readOnly ? [] : this.submissions,
			);
			this.loadForm(result, form.parent, {
				kid:  formKid,
				name: form.name,
			}, form.create, true);
		}
		catch (error) {
			this.loading = false;
			console.error(error);
		}
	}

	renderFileAsHTML(text) {
		this.$timeout(() => {
			const toParse = /<body>([\S\s]*)<\/body>/.exec(text);
			const parent = angular.element('#html-view');
			parent.empty();
			if (toParse?.length === 2) {
				const $compile = this.#$injector.get('$compile');
				// @ts-ignore
				const compiled = $compile($(`<div>${toParse[1]}</div>`))(_.extend(this.#$rootScope.$new(true), {
					$ctrl: {},
				}));
				parent.append(compiled[0]);
			}
			else {
				parent.append(text);
			}
		});
	}

	replaceKid(nr) {
		if (this.currentClassForm in nr) {
			this.currentClassForm = nr[this.currentClassForm];
			this.kid = this.currentClassForm;
		}
		this.$timeout(() => {
			for (const [oldKid, newKid] of Object.entries(nr)) {
				if (this.forms && oldKid in this.forms) {
					delete Object.assign(this.forms, { [newKid]: this.forms[oldKid] })[oldKid];
					this.forms[newKid].kid = newKid;
				}
				if (this.submissions && oldKid in this.submissions) {
					delete Object.assign(this.submissions, { [newKid]: this.submissions[oldKid] })[oldKid];
				}
				if (this.files && oldKid in this.files) {
					delete Object.assign(this.files, { [newKid]: this.files[oldKid] })[oldKid];
				}
				for (const [kid, submission] of Object.entries(this.submissions)) {
					for (const [k, data] of Object.entries(submission.data)) {
						if (Array.isArray(data)) {
							this.submissions[kid].data[k] = data.map(v => ({
								...v,
								kid: v.kid in nr ? nr[v.kid] : v.kid,
							}));
						}
					}
				}
			}
		});
	}

	/**
	 * Resets the current form
	 *
	 * @returns {Promise<boolean>} true if ok
	 */
	async reset() {
		let deleteCurrentForm = false;
		const returnValue = true;

		if (
			this?.currentClassForm
			&& this.forms
			&& this.currentClassForm in this.forms
			&& this.forms[this.currentClassForm].parent
		) {
			// on efface dans le formulaire parent la valeur qui vient d'être rajoutée
			// dans le traitement du formulaire courant.
			const parent = this.forms[this.currentClassForm].parent.kid;

			if (this.forms[this.currentClassForm].create && parent in this.submissions) {
				for (const [key, values] of Object.entries(this.submissions[parent].data)) {
					let indexToDelete = -1;
					if (Array.isArray(values)) {
						for (const [k, value] of values.entries()) {
							if (typeof value === 'object' && value.kid === this.currentClassForm) {
								indexToDelete = k;
							}
						}
						if (indexToDelete >= 0) {
							this.submissions[parent].data[key].splice(indexToDelete, 1);
						}
					}
				}
				deleteCurrentForm = true;
			}
		}

		if (this.currentClassForm in this.#oldData) {
			if (this.currentClassForm in this.forms && this.forms[this.currentClassForm].create) {
				deleteCurrentForm = true;
			}
			else if (this.currentClassForm in this.submissions) {
				this.submissions[this.currentClassForm].data = this.#oldData[this.currentClassForm].form;
				this.forms[this.currentClassForm].droit = this.#oldData[this.currentClassForm].droit;
				this.forms[this.currentClassForm].droitcust = this.#oldData[this.currentClassForm].droitcust;
				this.forms[this.currentClassForm].droitdef = this.#oldData[this.currentClassForm].droitdef;
				this.forms[this.currentClassForm].workflow = this.#oldData[this.currentClassForm].workflow;
				this.$timeout(() => {
					this.#$scope.$apply();
				});

				if (this.forms[this.currentClassForm].script) {
					this.$timeout(() => {
						this.kexecScriptWrapper(this.currentClassForm, {
							origin: 'kform',
							method: 'reset',
						}); // jshint ignore:line
					}, 500);
				}
			}
		}

		if (this.currentClassForm in this.#oldFiles && this.currentClassForm in this.files) {
			_.extend(this.files[this.currentClassForm], this.#oldFiles[this.currentClassForm]);
			if (this.files[this.currentClassForm]) {
				this.files[this.currentClassForm].loaded = true;
			}
		}

		if (this.forms && this.currentClassForm && this.currentClassForm in this.forms) {
			const form = this.forms[this.currentClassForm];
			if (form.kid && form.lock.locked) {
				await this.unlock();
			}

			if (!form.parent) {
				if (this.row) {
					await this.row.update({ edit: false });
				}

				for (const [, f] of Object.entries(this.forms)) {
					if (!f.parent && f.nodes.length > 0) {
						f.nodes.map(f => this.recursiveDeleteForm(f.kid));
					}
				}
			}
			this.#$scope.$broadcast('ktable-refresh');

			this.$timeout(() => {
				form.modified = false;
				form.formio.kformForm?.$setPristine();
				form.formio.kformForm?.$setUntouched();
			});

			if (deleteCurrentForm) {
				this.#FormService.mfCacheDelete(form.isa.objid);
				this.recursiveDeleteForm(this.currentClassForm);
			}
		}

		return returnValue;
	}

	selectViewMode(viewMode) {
		this.options.viewMode = viewMode;

		switch (this.forms[this.currentClassForm].tab) {
		case 'file': {
			if (viewMode === 2) {
				this.forms[this.currentClassForm].tab = 'form';
			}
			break;
		}

		case 'details': {
			if (viewMode === 3) {
				this.forms[this.currentClassForm].tab = 'wf';
			}
			break;
		}

		default: {
			this.forms[this.currentClassForm].tab = 'form';
		}
		}

		if (!this.options.modal) {
			this.#$location.search({
				mode: viewMode,
				tab:  this.forms[this.currentClassForm].tab,
			})
				.replace();
		}
	}

	setName() {
		this.name = this.getName(this.forms[this.currentClassForm]);
		this.#$rootScope.title = this.name + (this.create ? ` (${this.#$translate.instant('common.creation')})` : '');
	}

	/**
	 * Submits the current form
	 *
	 * @param {'submit' | 'save' | undefined} action action of the submit button
	 */
	async submit(action) {
		if (!action) {
			// eslint-disable-next-line no-param-reassign
			action = this.forms[this.currentClassForm].parent && this.forms[this.currentClassForm].parent.kid in this.forms
				? 'submit' : 'save';
		}

		// if the current form has a parent, return to it
		if (action === 'submit') {
			const form = this.forms[this.currentClassForm];
			const { parent } = form;

			if (!form.kndef?.NAME_ONFLY?.OBJECT) {
				const classNode = await this.#NodeService.load(form.isa.objid);
				form.kndef = classNode.kndef;
			}

			if (form.create && form.creating) {
				form.creating = false;
			}

			const nameOnFly = form.kndef.NAME_ONFLY?.OBJECT?.USE ?? null;
			const formChildIsDirty = form.formio.kformForm.$dirty;

			this.currentClassForm = parent.kid;
			this.$timeout(() => {
				if (formChildIsDirty && this.forms[this.selectedForm]) {
					this.forms[this.selectedForm].formio.kformForm.$setDirty();
					this.forms[this.currentClassForm].modified = true;
				}
				if (nameOnFly) {
					const updateName = () => nameOnFly.replaceAll(/\[([\w;]+)(?:#([\w;]+))?]/g, (m, kid, linkerKid = '0') => {
						// search in map
						const key = Object.keys(this.forms[this.selectedForm].map)
							.find(k => this.forms[this.selectedForm].map[k].path.at(-1).kid === kid
								&& this.forms[this.selectedForm].map[k].path.at(-1).linker_kid === linkerKid);

						let value = key && key in this.submissions[this.selectedForm].data
							? this.submissions[this.selectedForm].data[key] : '';

						if (Array.isArray(value) && value.length > 0) {
							value = value[0].name;
						}
						else if (typeof value === 'object' && 'name' in value) {
							value = value.name;
						}

						return typeof value === 'string' ? value.replaceAll(/\s{2,}/g, ' ')
							.trim() : '';
					});

					// recherche du MF dans le form parent
					for (const [k, v] of Object.entries(this.submissions[parent.kid].data)) {
						if (k === parent.field) {
							if (Array.isArray(v) && v.length > 0) {
								this.submissions[parent.kid].data[k][parent.k].name = updateName();
							}
							else if (typeof v === 'object' && 'name' in v) {
								this.submissions[parent.kid].data[k].name = updateName();
							}
							else if (typeof v === 'string') {
								this.submissions[parent.kid].data[k] = updateName();
							}
						}
					}
				}

				this.selectedForm = parent.kid;
				this.setName();
				if (this.forms[this.currentClassForm].script) {
					this.kexecScriptWrapper(this.currentClassForm, {
						origin: 'kform',
						method: 'submit',
					});
				}
				this.$timeout(() => {
					if (this.forms[this.currentClassForm].modified) {
						this.forms[this.currentClassForm].formio.kformForm.$setDirty();
					}
				});
			});
		}
		else if (action === 'save') {
			let saveForms = true;
			if (typeof this.onBeforeSubmit === 'function') {
				await this.onBeforeSubmit({
					forms:       this.forms,
					submissions: this.submissions,
					files:       this.files,
				});
			}

			if (this.options.mode === 'component_of' && typeof this.onSubmit === 'function') {
				this.onSubmit({
					forms:       this.forms,
					submissions: this.submissions,
					files:       this.files,
				});
				saveForms = !this.#formParent.create;
			}

			if (saveForms) {
				this.loading = true;
				const filesToUpload = [];

				if (Object.keys(this.files).length > 0) {
					for (const [, files] of Object.entries(this.files)) {
						filesToUpload.push(...files.filter(f => f.file && !f.uploaded && !f.deleted));
					}
				}

				if (filesToUpload.length > 0) {
					const modalInstance = this.#$uibModal.open({
						ariaLabelledBy:  'modal-uploading-title',
						ariaDescribedBy: 'modal-uploading-body',
						backdrop:        false,
						controller:      ModalUploadingController,
						controllerAs:    '$ctrl',
						template:        templateModalUploadClassic,
						size:            'sm',
						resolve:         {
							files: () => filesToUpload,
						},
						windowClass:     'modal-upload',
					});
					const modalUpload = await modalInstance.opened;

					if (modalUpload) {
						await this.submitForms();
						this.$timeout(() => {
							modalInstance.close();
						}, 3000);
					}
				}
				else {
					await this.submitForms();
				}
			}
		}
		else {
			console.error('Unknown action:', action);
		}
	}

	/**
	 * Submit all forms
	 *
	 * @returns {import('angular').IPromise} Promise result
	 */
	async submitForms() {
		try {
			await Object.keys(this.forms)
				.map(kid => {
					this.forms[kid].kid = kid;
					return this.forms[kid].upload.bind(
						this.forms[kid],
						this.files[kid],
						this.submissions[kid],
					);
				})

				// Uploads updated or new files from file tab
				// eslint-disable-next-line unicorn/no-array-reduce
				.reduce(async (promise, asyncFunction) => {
					const resultUpload = await promise;
					if (resultUpload && this.row) {
						await this.row.update({
							file: 1,
						});
					}
					return asyncFunction();
				}, Promise.resolve());

			// Gets files from MF fields inside the form
			await this.#FormService.getFilesInForm(this.submissions);

			this.#$scope.$emit('Form.save');

			// Calls the API to save the entire form (KFormSet)
			const result = await this.#FormService.save(this.forms, this.submissions);

			// After successful saving, runs the following code
			const currentName = this.currentClassForm && this.currentClassForm in this.forms
				&& this.forms[this.currentClassForm].getName();

			if (result) {
				// Merge returned data to existing form
				for (const k of Object.keys(this.forms)) {
					if (k in result.forms) {
						if (!this.forms[k].create) {
							delete result.forms[k].components[1]?.options?.parent;
						}
						_.merge(this.forms[k], result.forms[k]);

						this.forms[k].modified = false;
						if (this.forms[k].formio?.kformForm) {
							this.forms[k].formio?.kformForm.$setPristine();
							this.forms[k].formio?.kformForm.$setUntouched();
						}
					}
					else {
						delete this.forms[k];
					}
				}

				// Merge returned data to existing submission
				for (const k of Object.keys(this.submissions)) {
					if (k in result.submission) {
						this.submissions[k].data = result.submission[k].data;
					}
					else {
						delete this.submissions[k];
					}
				}

				// Update map
				for (const k of Object.keys(this.forms)) {
					this.forms[k].updateMap(result.submission[k].data);
				}

				// Relauch queries in all ktable components
				this.#$scope.$broadcast('ktable-refresh');

				this.$timeout(async () => {
					this.#$scope.$apply();

					// Reexecutes the script
					if (this.currentClassForm in this.forms && this.forms && this.forms[this.currentClassForm].script) {
						this.kexecScriptWrapper(this.currentClassForm, {
							origin: 'kform',
							method: 'submitForms',
						});
					}
				});

				const itemKid = Object.keys(result.forms)[0];

				// Set "create" flag to false and reset WF editor
				for (const form of Object.values(this.forms)) {
					form.create = false;
					form.workflow.length = 0;
				}

				if (this.create) {
					this.#Notification.success({
						title:   this.#$translate.instant('object.successfully-created-title'),
						message: this.#$translate.instant('object.successfully-created-message'),
					});
				}
				else {
					this.#Notification.success({
						title:   this.#$translate.instant('object.successfully-updated-title'),
						message: this.#$translate.instant('object.successfully-updated-message'),
					});
				}
				this.loading = false;

				if (this.forms[this.currentClassForm]?.parent?.kid in this.forms) {
					await this.submit('submit');
				}
				else if (typeof this.onSubmit === 'function') {
					this.onSubmit({
						itemKid,
						itemName: currentName,
					});
				}
				this.options.readOnly = true;
			}
			else {
				this.loading = false;
			}

			if (this.row) {
				this.forms[this.currentClassForm].lock = new Lock();
				await this.row.update({
					edit:          false,
					lock:          this.forms[this.currentClassForm].lock,
					name:          this.forms[this.currentClassForm].getName(),
					viewer_engine: this.forms[this.currentClassForm].viewer_engine,
				});
			}

			if (this.forms[this.currentClassForm]?.viewer_engine === 'html') {
				this.renderFileAsHTML(this.files[this.currentClassForm].url);
			}

			this.#$scope.$broadcast('Form.submitted');
		}
		catch (error) {
			// In case of failure, stop the loading indicator
			console.error(error);
			this.$timeout(() => {
				this.loading = false;
			});
		}
	}

	trustAsHtml(string) {
		return this.#$sce.trustAsHtml(string);
	}

	/**
	 * Unlocks the current form
	 */
	async unlock() {
		if (this.currentClassForm in this.forms && !this.forms[this.currentClassForm].create) {
			const form = this.forms[this.currentClassForm];
			await this.#FormService.unlock(form);
			form.lock = new Lock();
			this.options.readOnly = true;

			if (this.row) {
				await this.row.update({
					lock: form.lock,
					edit: false,
				});
			}
		}
	}

	/**
	 * Update the KID of a form
	 *
	 * @param {import('~/scripts/services/model/form').default} form
	 */
	updateKid(form) {
		const oldKid = this.currentClassForm;
		const newKid = form.kid;

		if (oldKid !== newKid) {
			Object.defineProperty(
				this.forms,
				newKid,
				Object.getOwnPropertyDescriptor(this.forms, oldKid),
			);
			delete this.forms[oldKid];

			Object.defineProperty(
				this.submissions,
				newKid,
				Object.getOwnPropertyDescriptor(this.submissions, oldKid),
			);
			delete this.submissions[oldKid];

			Object.defineProperty(
				this.files,
				newKid,
				Object.getOwnPropertyDescriptor(this.files, oldKid),
			);
			delete this.files[oldKid];

			this.currentClassForm = newKid;
			this.$timeout(() => {
				this.forms[this.currentClassForm].formio.kformForm.$setDirty();
			});
		}
	}

	$onChanges(changes) {
		if (changes.currentClassForm && changes.currentClassForm.currentValue !== changes.currentClassForm.previousValue) {
			this.setName();
		}

		if (changes.kid) {
			this.loadGraph = false;
			let pass = false;
			if (changes.kid.currentValue && changes.kid.currentValue !== changes.kid.previousValue) {
				pass = changes.kid.previousValue ? this.reset() : true;
				if (pass) {
					this.#rootFormKid = null;
				}
			}

			// noinspection DuplicatedCode
			if (pass) {
				this.forms = {};
				this.files = {};
				this.submissions = {};
				if (this.options?.readOnly === undefined) {
					this.options.readOnly = !this.create;
				}
				if (this.row) {
					(async () => this.row.update({ edit: false }))();
				}
				(async () => this.addForm(this.create ? { isa: this.kid } : { kid: this.kid }, null))();
			}
		}

		if (changes.name) {
			this.#$rootScope.title = changes.name.currentValue ?? null;
		}

		if (changes.row?.currentValue && changes.row?.currentValue !== changes.row?.previousValue) {
			this.kid = this.row?.getData().kid;
			const newIsa = this.row?.getData().new_isa;

			this.loadGraph = false;
			const pass = changes.row.previousValue ? this.reset() : true;
			if (!pass && changes.row.previousValue) {
				this.$timeout(() => {
					changes.row.previousValue.deselect();
				});
			}
			else {
				this.#rootFormKid = null;
			}

			// noinspection DuplicatedCode
			if (pass) {
				this.forms = {};
				this.files = {};
				this.submissions = {};
				this.options.readOnly = !this.create;
				if (this.row) {
					(async () => this.row.update({ edit: false }))();
				}
				(async () => this.addForm(
					this.create ? { isa: this.kid } : { kid: this.kid },
					null,
					{ new_isa: newIsa },
				))();
			}
		}

		if (changes.tab && changes.tab?.currentValue !== changes.tab?.previousValue) {
			this.options.tab = changes.tab.currentValue;
			this.#$location.search('tab', this.options.tab)
				.replace();
			if (this.currentClassForm === this.#rootFormKid) {
				this.forms[this.currentClassForm].tab = this.options.tab;
			}
		}
	}

	isInteraction() {
		return this.forms[this.currentClassForm].isa.objid === 'K_NODE;cENTRETIEN';
	}

	isPerson() {
		return this.forms[this.currentClassForm].isa.objid === 'K_NODE;PERSON_OWNER';
	}

	isProject() {
		const projectsKid = [
			'K_NODE;PROJECT',
			'K_NODE;cPROJECTCIAL',
		];
		return projectsKid.includes(this.forms[this.currentClassForm].isa.objid);
	}

	openAktivNote() {
		window.open(`/front5/aktivnote/note?interaction=${this.kid}`);
	}

	openProjectMatrix() {
		window.open(`/front5/aktivnote/matrix?project=${this.kid}`);
	}

	openPersonMatrix() {
		window.open(`/front5/aktivnote/matrix?people=${this.kid}`);
	}

	$onInit() {
		const scopeParent = this.#$scope.$parent;
		this.#formParent = scopeParent.form;

		kformUtils.init({
			kform: this,
		});

		this.#newKid = this.#$location.search().newKid;
		this.from = this.#$location.search().from;
		this.user = this.#$rootScope.context;

		this.options = {
			...this.defaultOptions,
			...this.options,
		};

		/**
		 * Downloads the file from the current form and opens it using the Knitiv Agent
		 */
		this.openWithKnitivAgent = this.#Agent.openFile;

		this.sign = kid => {
			this.$timeout(() => {
				this.#$location
					.path(`/e-sign/${kid}`)
					.search({
						return: window.location.pathname + window.location.search,
					});
			});
		};

		// Events ------------------------------------------
		this.#$scope.$on('Form.nrReplace', (_event, nr) => {
			this.replaceKid(nr);
		});

		this.#$scope.$on('kexecScript', (_event, formKid, source) => this.kexecScriptWrapper(formKid, source));

		this.#$scope.$on('Form.refresh', () => this.refreshForm());

		this.#$scope.$on('Form.set-new-isa', async (
			/** @type {Event} */ _event,
			/** @type {?import('@knitiv/api-client-javascript').KNode} */ newIsa,
		) => {
			if (this.row) {
				this.options.new_isa = newIsa;
				this.forms[this.#rootFormKid].new_isa = newIsa;

				if (this.currentClassForm) {
					this.currentClassForm = this.#rootFormKid;
				}
				const form = this.forms[this.currentClassForm];
				const formKid = form.kid;

				this.loading = true;

				if (form.components) {
					form.components.length = 0;
				}
				else {
					form.components = [];
				}

				try {
					const result = await this.#FormService.load(
						form.kid,
						{
							create:  false,
							new_isa: newIsa,
							rg:      true,
						},
					);
					await this.loadForm(result, form.parent, {
						kid:  formKid,
						name: form.name,
					}, form.create, true);
					await this.edit();
				}
				catch (error) {
					this.loading = false;
					console.error(error);
				}
			}
		});

		this.#$scope.$on('updateComponent', (_event, key, newComponent) => {
			if (this.currentClassForm in this.forms) {
				this.forms[this.currentClassForm].updateComponent(key, newComponent);
			}
		});

		this.#$scope.$on('Form.update', (_event, form) => {
			if (this.forms && form.kid in this.forms && this.forms[form.kid]) {
				_.merge(this.forms[form.kid].components, form.components);

				if (this.forms[form.kid].formio.kformForm) {
					for (const key of Object.keys(this.forms[form.kid].map)) {
						if (key in this.forms[form.kid].formio.kformForm) {
							// Exception for radio buttons
							if (key in this.forms[form.kid].formio.kformForm[key]) {
								this.forms[form.kid].formio.kformForm[key][key].$validate();
							}
							else {
								this.forms[form.kid].formio.kformForm[key].$validate();
							}
						}
					}
				}
			}
		});

		this.#$scope.$on('Form.updateSubmission', (_event, submission) => {
			if (this.currentClassForm in this.forms && this.currentClassForm in this.submissions) {
				_.merge(this.submissions[this.currentClassForm], submission);
			}
		});

		this.#$scope.$on('$destroy', () => {
			if (!this.options.parent) {
				this.#rootFormKid = null;
			}
		});

		this.connectedAgent = this.#Agent.connected;

		// this.user = this.#$rootScope.user; // TODO: is it necessary?

		// if (this.kid) {
		// 	this.addForm(this.create ? { isa: this.kid } : { kid: this.kid }, null);
		// }

		this.#$scope.$watch('$ctrl.submissions', (submissions, oldSubmissions) => {
			if (
				submissions
				&& submissions[this.currentClassForm]
				&& !_.isEqual(submissions[this.currentClassForm], oldSubmissions[this.currentClassForm])
				&& !this.loading
				&& oldSubmissions && this.currentClassForm in oldSubmissions
			) {
				const keys = Object.keys(_.omitBy(submissions[this.currentClassForm].data,
					(v, k) => (
						oldSubmissions[this.currentClassForm].data[k] === undefined
						&& _.isEqual(v, [])
					) || _.isEqualWith(
						oldSubmissions[this.currentClassForm].data[k],
						v,
						(v1, v2) => {
							if (v1?.kid && v2?.kid && v1.kid === v2.kid && v1.name === v2.name) {
								return true;
							}
							if (Array.isArray(v1) && Array.isArray(v2)) {
								return _.isEqualWith(v1, v2, (v11, v12) => v11?.kid === v12?.kid && v11?.name === v12?.name);
							}

							return false;
						},
					)));

				for (const key of keys) {
					if (!dataChanged.includes(key)) {
						dataChanged.push(key);
					}
				}

				if (this.currentClassForm in this.forms) {
					this.forms[this.currentClassForm].modified = dataChanged.length > 0;
				}
			}
		}, true);

		this.loading = true;
	}
}
